<template>
  <div class="questionnaire">
    <p class="tips">
      <i class="el-icon-info"></i>
      <span
        >请根据自身情况如实回答以下问题。</span
      >
    </p>
    <div class="questions">
      <div
        class="question-item"
        v-for="(item, idx) in questionnaireInfo.questionList"
        :key="item.questionId"
      >
        <p>{{ idx + 1 }}.{{ item.question }}</p>
        <el-radio
          v-model="questionnaireInfo.answerMap[item.questionId]"
          v-for="o in optionList"
          :key="o.id"
          :label="o.tag"
          style="margin-top: 20px"
          >{{ o.tag }}.{{ o.label }}</el-radio
        >
      </div>
    </div>

    <el-button type="primary" size="medium" @click="handleSubmit">{{
      questionnaireInfo.isSubmit ? "重新提交" : "提 交"
    }}</el-button>
  </div>
</template>

<script>
import { questionInfo, submit } from "@/api/projectPractice/questionnaire";
export default {
  data() {
    return {
      questionnaireInfo: {},
      optionList: [
        { id: 1, tag: "A", label: "优秀" },
        { id: 2, tag: "B", label: "良" },
        { id: 3, tag: "C", label: "一般" },
        { id: 4, tag: "D", label: "差" },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$loading.show();
      questionInfo({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.questionnaireInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 提交
    handleSubmit() {
      this.$confirm("确定要提交吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          submit({
            classId: this.$route.query.id,
            answerMap: this.questionnaireInfo.answerMap,
          }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("提交成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.questionnaire {
  .tips {
    padding: 0 10px;
    margin-bottom: 20px;
    color: #f56c6c;
    text-align: left;
    i {
      margin-right: 5px;
    }
  }
  .questions {
    padding: 0 10px;
    text-align: left;
    ::v-deep .question-item {
      display: block;
      margin-bottom: 15px;
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: inherit;
      }
    }
  }
}
</style>